import { Select, SelectProps } from "@reverb-ui/react";

const customStyles = {
  container: (provided: any) => ({
    flex: 1,
    width: "100%",
    ...provided,
  }),
  menu: (provided: any) => ({
    ...provided,
    zIndex: 1000,
  }),
  menuPortal: (provided: any) => ({
    ...provided,
    zIndex: 1000,
  }),
  control: (provided: any) => ({
    width: "100%",
    ...provided,
  }),
};

export function CustomSelect(props: SelectProps): JSX.Element {
  return (
    <Select
      styles={customStyles}
      {...props}
      menuPortalTarget={document.querySelector("body")}
    />
  );
}
